import React, {createContext, useContext, useReducer} from 'react'
import {LidarOverviewReducer} from "../reducer/LidarOverviewReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const LidarOverviewContext = createContext();

const LidarOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        lidarDeviceInformation: {},
        macAddressArray: [],
        deviceConnectivityList: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(LidarOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }

    return (
        <LidarOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </LidarOverviewContext.Provider>
    )
}

export default LidarOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/context/LidarOverviewContext.js